var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseStroke18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63325 14.3359C2.35102 14.6182 2.34272 15.0996 2.63325 15.3818C2.92378 15.6641 3.40522 15.6641 3.68745 15.3818L8.99995 10.0693L14.3125 15.3818C14.5947 15.6641 15.0844 15.6724 15.3666 15.3818C15.6489 15.0913 15.6489 14.6182 15.3666 14.3359L10.0541 9.01515L15.3666 3.70265C15.6489 3.42042 15.6572 2.93898 15.3666 2.65675C15.0761 2.36622 14.5947 2.36622 14.3125 2.65675L8.99995 7.96925L3.68745 2.65675C3.40522 2.36622 2.91548 2.35792 2.63325 2.65675C2.35102 2.94728 2.35102 3.42042 2.63325 3.70265L7.94575 9.01515L2.63325 14.3359Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseStroke18);
export default __webpack_public_path__ + "static/media/Close_Stroke_18.a6401afae8e1b2593cc8f0a0028e187d.svg";
export { ForwardRef as ReactComponent };